export interface IOrderSetup {
  defaultQuantity?: number;
  defaultUnitId?: number;
}
